<template>
  <div class="col-12 row q-col-gutter-x-sm items-center">
    <model-form-select
      :field="membershipTiersField"
      class="col-12"
      label="Tiers"
      :options="membershipTiers"
      option-label="name"
      option-value="id"
      map-options
      emit-value
      multiple
      use-chips
      clearable
      :rules="[
        val => !!val || 'Field is required',
        val => val.length > 0 || 'Must select at least one tier'
      ]"
    />
  </div>
</template>

<script>
import { CONDITION_REQUIREMENTS } from 'src/models/membership-type/MembershipPoint'

export default {
  name: 'TierConditionForm',
  props: {
    conditional: {
      type: Object,
      required: true
    },
    membershipTiersField: {
      type: String,
      default: CONDITION_REQUIREMENTS.TIER
    },
    membershipTiers: {
      type: Array,
      required: true
    }
  }
}

</script>
